import { createContext } from 'react'

import { IBreadcrumbsContextProps } from './types'

export const BreadcrumbsContext = createContext({} as IBreadcrumbsContextProps)
